<template>
    <div>
        <!-- 配置 -->
        <div style="display: flex;justify-content: space-between;align-items: center;">
            <h3>基本设置</h3>
            <el-button size="mini" @click="refesh" type="primary">刷新</el-button>
        </div>
        <!-- 水平线 -->
        <el-divider></el-divider>
        <el-form label-width="140px" :model="option">
            <el-form-item :label="$t('lang.smartsms.mobileNetwork')">
                <el-select size="mini" class="input" v-model="option.modem">
                    <el-option label="3gwan1" value="1"></el-option>
                    <el-option v-if="hardware_class.indexOf('DMDC') == -1" label="3gwan2" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('lang.smartsms.SIM1Number')">
                <el-input class="input" size="mini" v-model="option.phone1"></el-input>
            </el-form-item>
            <el-form-item :label="$t('lang.smartsms.storageLocation')">
                <el-select size="mini" class="input" v-model="option.memory">
                    <el-option :label="$t('lang.smartsms.SIMCard')" value="SM"></el-option>
                    <el-option :label="$t('lang.smartsms.equipmentTerminal')" value="ME"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('lang.smartsms.SMSCenter')">
                <el-input class="input" size="mini" v-model="option.center"></el-input>
                <p class="tips">{{ $t('lang.smartsms.tips1') }}</p>
            </el-form-item>
            <el-form-item :label="$t('lang.smartsms.whitelist')">
                <div v-for="(item, index) in option.whitelist">
                    <el-input class="input" size="mini" v-model="option.whitelist[index]"></el-input>
                    <el-button v-if="index === option.whitelist.length - 1" @click="addWhite" type="primary"
                        icon="el-icon-plus" size="mini" style="margin-left: 10px;"></el-button>
                    <el-button v-else @click="removeWhite(index)" type="danger" icon="el-icon-minus" size="mini"
                        style="margin-left: 10px;"></el-button>
                </div>
                <p class="tips">{{ $t('lang.smartsms.tips1') }}</p>
            </el-form-item>
            <el-form-item :label="$t('lang.smartsms.validityPeriod')">
                <el-select class="input" size="mini" v-model="option.validity" @change="validityChange" v-if="!isInput">
                    <el-option v-for="item in validityPeriodList" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                    <el-option value="-1" label="自定义"></el-option>
                </el-select>
                <el-input v-else size="mini" class="input" v-model="inputValue" @blur="inputBlur"></el-input>
                <p class="tips">0 ~ 255</p>
            </el-form-item>
            <el-form-item :label="$t('lang.smartsms.DetectionCycle')">
                <el-input class="input" size="mini" v-model="option.interval"></el-input>
                <p class="tips">{{ $t('lang.smartlink.seconds') }}</p>
            </el-form-item>
            <el-form-item label="删除检测周期">
                <el-input class="input" size="mini" v-model="option.delinterval"></el-input>
                <p class="tips">{{ $t('lang.smartlink.seconds') }}</p>
            </el-form-item>
            <!-- 自动删除 -->
            <el-form-item label="自动删除">
                <el-checkbox v-model="option.automatic_del"></el-checkbox>
            </el-form-item>
            <el-form-item label="自动删除阈值上限" v-if="option.automatic_del">
                <el-input class="input" v-model="option.del_up_thr" size="mini"></el-input>
                <p class="tips">收信箱存储空间达到阈值上限后，触发自动删除，0%~100%默认值90</p>
            </el-form-item>
            <el-form-item label="自动删除阈值下限" v-if="option.automatic_del">
                <el-input class="input" v-model="option.del_low_thr" size="mini"></el-input>
                <p class="tips">收信箱存储空间达到阈值下限后，触发自动删除，0%~100%默认值50</p>
            </el-form-item>
        </el-form>
        <div class="foot">
            <el-button @click="saveClick" size="mini" type="primary">{{ $t('lang.smartsms.saveAndApply') }}</el-button>
            <!-- <el-button size="mini" >重置</el-button> -->
        </div>
    </div>
</template>

<script>
export default {
    name: "",
    props: ['hardware_class'],
    data() {
        return {
            option: {
                modem: '',
                phone1: '',
                memory: '',
                validity: '',
                interval: '',
                center: '',
                del_up_thr: '',
                automatic_del: false,
                del_low_thr: '',
                whitelist: [],
                delinterval: '',
            },
            validityPeriodList: [
                {
                    label: "5分钟",
                    value: "0",
                },
                {
                    label: "10分钟",
                    value: "1",
                },
                {
                    label: "20分钟",
                    value: "3",
                },
                {
                    label: "30分钟",
                    value: "5",
                },
                {
                    label: "1小时",
                    value: "11",
                },
                {
                    label: "6小时",
                    value: "71",
                },
                {
                    label: "12小时",
                    value: "143",
                },
                {
                    label: "1天",
                    value: "167",
                },
                {
                    label: "5天",
                    value: "171",
                },
                {
                    label: "10天",
                    value: "176",
                },
                {
                    label: "20天",
                    value: "186",
                },
                {
                    label: "30天",
                    value: "196",
                },
                {
                    label: "5周",
                    value: "197",
                },
                {
                    label: "10周",
                    value: "202",
                },
                {
                    label: "20周",
                    value: "212",
                },
                {
                    label: "30周",
                    value: "222",
                },
            ],
            isInput: false,
            inputValue: ""
        };
    },
    methods: {
        addWhite() {
            this.option.whitelist.push('')
        },
        removeWhite(index) {
            this.option.whitelist.splice(index, 1)
        },
        saveClick() {
            this.$emit('save', {
                options: {
                    modem: this.option.modem,
                    phone1: this.option.phone1 ? this.option.phone1 : undefined,
                    memory: this.option.memory,
                    validity: this.option.validity,
                    interval: this.option.interval,
                    center: this.option.center ? this.option.center : undefined,
                    delinterval: this.option.delinterval,
                    del_up_thr: this.option.del_up_thr,
                    automatic_del: this.option.automatic_del ? '1' : '0',
                    del_low_thr: this.option.del_low_thr
                },
                lists: {
                    whitelist: this.option.whitelist.filter(item => item.length > 0)
                }
            })
        },
        refesh() {
            this.$emit('refesh')
        },
        validityChange() {
            if (this.option.validity == -1) {
                this.isInput = true
            }
        },
        inputBlur() {
            if (this.inputValue == "" || this.inputValue == null) {
                this.isInput = false
                return
            }
            this.isInput = false
            this.validityPeriodList.unshift({
                label: this.inputValue,
                value: this.inputValue,
            })
            this.option.validity = this.inputValue
            this.inputValue = ""
        }
    },

};
</script>
<style scoped>
h3 {
    font-size: 16px;
}

.input {
    width: 320px;
}

.tips {
    color: #999;
    font-size: 12px;
}

.foot {
    display: flex;
    justify-content: end;
}
</style>